export enum ColorType {
    Primary = '#0476D9',
}
